import { createUseStyles } from 'react-jss';

import { FontWeight, ITheme, IThemeColorName } from '../../../styles';

import { AlertVariant } from './types';

const getVariantColor = (variant: AlertVariant): IThemeColorName =>
  variant === 'success' ? 'white' : 'black';

const getVariantBackground = (variant: AlertVariant) =>
  variant === 'success' ? 'success' : 'warning';

const useStyles = createUseStyles<string, { variant: AlertVariant }>(
  ({ colors }: ITheme) => ({
    root: {
      padding: [12, 16],
      background: ({ variant }) => colors[getVariantBackground(variant)],
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      boxShadow: '0px 0px 16px rgba(0, 0, 0, 0.16)',
      borderRadius: '12px',
      gap: 8,
    },
    main: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: 8,
    },
    icon: {
      display: 'flex',
      alignItems: 'center',

      '& svg': {
        fill: ({ variant }) => colors[getVariantColor(variant)],
      },
    },
    message: {
      color: ({ variant }) => colors[getVariantColor(variant)],
      fontSize: '16px',
      fontWeight: FontWeight.SemiBold,
      lineHeight: '24px',
    },
    btnClose: {
      padding: 0,
      margin: 0,
      outline: 'none',
      background: 'transparent',
      boxShadow: 'none',
      border: '0',
      cursor: 'pointer',
      display: 'flex',

      '& svg': {
        fill: ({ variant }) => colors[getVariantColor(variant)],
      },
    },
  }),
  { name: 'Alert', link: true },
);

export default useStyles;
